import {
  Chart as ChartJS, CategoryScale, LinearScale,
  BarElement, Title, Tooltip, Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function VarianceBarChart({ variances }) {
  // Take top 5 by absolute variance value
  const top5 = [...variances]
    .sort((a,b) => Math.abs(b.variance) - Math.abs(a.variance))
    .slice(0, 5);

  const labels = top5.map(v =>
    v.category.length > 14 ? v.category.substring(0,12) + '..' : v.category
  );

  const data = {
    labels,
    datasets: [{
      label: 'Variance ($)',
      data: top5.map(v => v.variance),
      backgroundColor: top5.map(v => v.favorable ? '#15803D' : '#BE123C'),
      borderRadius: 4,
    }],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: false },
    },
    scales: {
      y: { grid: { color: '#F1F5F9' } },
      x: { grid: { display: false } },
    },
  };

  return <Bar data={data} options={options} />;
}

export default VarianceBarChart;
